module.exports = __webpack_public_path__ + "static/media/radio_button_unchecked_blue.21b4c07b.svg";